import React, { FC, useState } from "react";
import { MobileMenu } from "./MobileMenu";
import { InternalLink } from "../../links/InternalLink";
import {
  BrandConfigCustomizationsImage,
  PortalHeaderLocalization,
} from "../../../types/graphql/generated";
import {
  StyledHeader,
  StyledLogo,
  StyledNavLeft,
  StyledNavLink,
  StyledNavLinksWrapper,
} from "./index.styled";

export interface NavigationLink {
  location: string;
  newTab: boolean;
  position: number;
  title: string;
  url: string;
}

interface PortalHeaderProps {
  fallbackUrl?: string;
  handleKeyDown: (e: React.KeyboardEvent) => void;
  links: NavigationLink[];
  logo?: BrandConfigCustomizationsImage | null;
  pathname: string;
  signOut: () => void;
  headerLocalization?: PortalHeaderLocalization | null;
}

export const PortalHeader: FC<PortalHeaderProps> = ({
  fallbackUrl,
  handleKeyDown,
  links,
  logo,
  pathname,
  signOut,
  headerLocalization,
}) => {
  const { signOutLinkText = "Sign Out" } = headerLocalization || {};
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleSignout = () => {
    setMenuOpen(false);
    signOut();
  };

  return (
    <StyledHeader isMenuOpen={isMenuOpen}>
      {/* Mobile menu 🍔 */}
      <MobileMenu
        isMenuOpen={isMenuOpen}
        links={links}
        setMenuOpen={setMenuOpen}
      />
      <StyledNavLeft>
        {/* Logo */}
        <InternalLink href={fallbackUrl || ""}>
          <StyledLogo alt={logo?.alt || "logo"} src={logo?.src || ""} />
        </InternalLink>
        {/* Links */}
        <StyledNavLinksWrapper>
          {links?.map((link) => {
            const { position, title, url } = link;
            return (
              <InternalLink key={position} href={url}>
                <StyledNavLink
                  active={url.includes(pathname)}
                  onKeyDown={handleKeyDown}
                  role="link"
                  tabIndex={0}
                >
                  {title}
                </StyledNavLink>
              </InternalLink>
            );
          })}
        </StyledNavLinksWrapper>
      </StyledNavLeft>
      {/* Sign Out */}
      <StyledNavLink
        onKeyDown={handleKeyDown}
        onClick={handleSignout}
        role="link"
        tabIndex={0}
      >
        {signOutLinkText}
      </StyledNavLink>
    </StyledHeader>
  );
};
